export const SET_PAYMENT_HISTORY = "SET_PAYMENT_HISTORY";
export const SET_FILTERED_PAYMENT_HISTORY = "SET_FILTERED_PAYMENT_HISTORY";
